import { createApiSlice } from "@common";
import {
  CRUD_INQUIRY_TAGGING,
  CRUD_INQUIRY_TAGGING_ID
} from "@routes";
// Define the API config array
// 1 to 1
const apiConfig = [
  {
    name: "addInquiryTagging",
    method: "post",
    url: CRUD_INQUIRY_TAGGING,
    stateKey: "message",
  },
  {
    name: "getInquiryTaggingById",
    method: "get",
    url: CRUD_INQUIRY_TAGGING_ID,
    stateKey: "data",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "inquiryTagging",
  apiConfig,
  customReducers,
);
const inquiryTaggingSlice = slice;

// Export the slice's reducer
export default inquiryTaggingSlice.reducer;

// Export thunks
export const {
  addInquiryTagging,
  getInquiryTaggingById,
} = thunks;

// Export actions
export const { rowSelect } = actions;
